// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"fa19139a","644":"25ca61e4","667":"08e2529e"}[chunkId] + ".js";
};